import { render, staticRenderFns } from "./Excel.vue?vue&type=template&id=e3952048&scoped=true&"
import script from "./Excel.vue?vue&type=script&lang=js&"
export * from "./Excel.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/resident.css?vue&type=style&index=0&id=e3952048&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3952048",
  null
  
)

export default component.exports